const productCategoriesUrl = 'product_categories/';

export default { productCategoriesUrl };
